import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DataSearchResult } from '../../enums/enums'

@Component({
  selector: 'ddc-search-result-dictionary',
  templateUrl: './ddc-search-result-dictionary.component.html',
  styleUrl: './ddc-search-result-dictionary.component.scss',
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcSearchResultDictionaryComponent {
  @Input() result!: DataSearchResult
  @Input() showIcon: boolean = true
  @Input() showTime: boolean = true
  @Output() dictionaryClick = new EventEmitter<DataSearchResult>()

  onDictionaryClick(): void {
    this.dictionaryClick.emit(this.result)
  }
}
